import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import { useAuthContext } from 'src/auth/hooks';
import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import { fetchInterviews } from 'src/services/interview.service';
import Editor from 'src/components/editor/editor';
import {
  getOrganizationDetails,
  getOrganizationId,
} from 'src/services/user.service';
import { ConfirmDialog } from 'src/components/custom-dialog';

export default function EmailPreviewModal({
  open,
  handleClose,
  orgName,
  subject,
  htmlText,
  valid_for,
  emailSendBtn,
  sendEmail,
}) {
  // context
  const { user } = useAuthContext();

  // router
  const params = useParams();

  // states
  const [jobName, setJobName] = useState('');
  let currentDate = new Date();
  let datePlus7 = new Date(currentDate);
  const validity = valid_for[0] - '0';
  datePlus7.setDate(currentDate.getDate() + validity);
  // const [html, setHtml] = useState(htmlText.current);
  let html = `${htmlText.current}`
    .replaceAll('{company}', orgName)
    .replaceAll('{jobName}', jobName)
    .replaceAll('{user_name}', user?.name)
    .replaceAll(
      '{expiry_date}',
      valid_for === 'not' ? '{expiry_date}' : datePlus7.toDateString(),
    );
  let subjectText = subject
    .replaceAll('{company}', orgName)
    .replaceAll('{jobName}', jobName)
    .replaceAll('{user_name}', user?.name)
    .replaceAll('{expiry_date}', datePlus7.toDateString());

  // effects
  useEffect(() => {
    if (params.jobId) {
      fetchInterviews(params.jobId)
        .then(res => {
          if (res.success) {
            setJobName(res.body.job_opening.name);
          }
        })
        .catch(err => console.log(err));
    }
  }, [params.jobId]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Email Preview</DialogTitle>
      <DialogContent
        sx={{
          paddingY: 0,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Stack width="100%" height="60vh" spacing={4} padding={2}>
          <Stack>
            <Typography variant="body1" fontWeight={600}>
              Subject
            </Typography>

            <Typography variant="body1" color="gray">
              {subjectText}
            </Typography>
          </Stack>
          <Stack>
            <Typography variant="body1" fontWeight={600}>
              Content
            </Typography>
            <Typography
              variant="body1"
              color="gray"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          {!emailSendBtn && (
            <Button variant="contained" onClick={handleClose}>
              Close
            </Button>
          )}
          {emailSendBtn && (
            <Button
              variant="contained"
              onClick={() => {
                sendEmail();
                handleClose();
              }}
            >
              Send Email
            </Button>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
}

EmailPreviewModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
